import flatten from 'lodash-es/flatten';
import {
  ProductClass,
} from '../../graphQL/types/shared';
import {
  IDropdownOption,
} from '../../Utils';
import {
  getProductDropdownLabel,
  getProductSearchString,
} from '../../Utils';
import {
  IEdge,
} from '../fetchedData/layoutData';
import {
  IMetadatum,
} from '../fetchedData/productMetadata';

interface IDropdownOptionWithCode {
  value: number;
  label: string;
  code: string;
  // String to search against:
  searchString: string;
}

const getDropdownOptions = (
    productClass: ProductClass,
    metadata: Map<number, IMetadatum>,
    edges: IEdge[],
  ): IDropdownOption[] => {

  const allConnectedNodes = flatten(edges.map(({source, target}) => ([source, target])));
  const allUniqueConnectedNodes = [...new Set(allConnectedNodes)];

  const unsortedResult: IDropdownOptionWithCode[] = allUniqueConnectedNodes.map(id => {
    const {code, name_short_en, level} = metadata.get(id)!;
    const label = getProductDropdownLabel(name_short_en, productClass, code, level);
    const searchString = getProductSearchString(name_short_en, productClass, code);
    const option: IDropdownOptionWithCode = {
      value: id,
      label, code,
      searchString,
    };
    return option;
  });

  const sorted = unsortedResult.sort(({code: codeA}, {code: codeB}) => {
    // Note: `code` are uniques:
    if (codeA < codeB) {
      return -1;
    } else {
      return 1;
    }
  });
  const result: IDropdownOption[] = sorted.map(
    ({value, label, searchString}) => ({value, label, searchString}),
  );
  return result;

};

export default getDropdownOptions;
